import { render, staticRenderFns } from "./academy_client.vue?vue&type=template&id=061719f0&"
import script from "./academy_client.vue?vue&type=script&lang=js&"
export * from "./academy_client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalClientChange: require('/home/smiley/3df/components/Modal/ModalClientChange/ModalClientChange.vue').default,ModalConfirmation: require('/home/smiley/3df/components/Modal/ModalConfirmation/ModalConfirmation.vue').default,NavClient: require('/home/smiley/3df/components/Nav/NavClient/NavClient.vue').default,NavClientMobile: require('/home/smiley/3df/components/Nav/NavClient/NavClientMobile.vue').default,Footer: require('/home/smiley/3df/components/Footer/Footer.vue').default})
